import { FormControlLabel, Checkbox } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { FC, useEffect, useState } from "react"
import { InputComboBoxList, InputText } from "src/framework/components/forms";
import { useObservable } from "src/framework/store/storeUtil";
import { bancos$ } from "src/store/global.store";
import { permiteDebitoEmConta$ } from "../../negociacao/Financiamento";
import { TIPO_CONTA } from "../constants";
import { IDadosBancariosDataRequestDom } from "../types"
import "./styles.scss";

interface FormDadosBancariosProperties {
    dadosBancarios: IDadosBancariosDataRequestDom,
    errorsList?: Array<string>;
    onChange: (dadosBancarios: IDadosBancariosDataRequestDom) => void;
    isValid?: (value: boolean) => void;
    readonly?: boolean;
    bancoId?: string | null;
}
const FormDadosBancarios: FC<FormDadosBancariosProperties> = ({
    dadosBancarios,
    isValid,
    errorsList = [],
    onChange,
    readonly = false,
    bancoId = null
}) => {
    const bancosListState = useObservable(bancos$);
    const [bancoSelecionado, setBancoSelecionado] = useState<any>(null);
    const [tipoConta, setTipoConta] = useState<any>(null);
    const [errors, setErrors] = useState<string[]>([]);
    const permiteDebitoEmConta = useObservable<boolean>(permiteDebitoEmConta$);

    const handleValidChange = () => {
        if (isValid) {
            isValid(errors.length <= 0);
        }
    }

    useEffect(() => {
        const banco = bancos$.getValue()?.data?.find((b: any) => b.id === bancoId);
        if (banco) {
            setBancoSelecionado(banco)

            dadosBancarios.banco = bancoId;
            onChange({ ...dadosBancarios });
        }
    }, [bancoId]);

    useEffect(() => {
        const tipo = TIPO_CONTA.find((t) => t.id === dadosBancarios?.tipo)
        setTipoConta(tipo)
    }, [dadosBancarios?.tipo])

    return <div className="FormDadosBancarios">
        <div className="row">
            <div className="X12 M6 column-debito-conta">
                <FormControlLabel
                    control={<Checkbox
                        disabled={readonly || permiteDebitoEmConta !== true}
                        value={dadosBancarios?.debito_em_conta}
                        checked={dadosBancarios?.debito_em_conta || false}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            if (dadosBancarios) {
                                dadosBancarios.debito_em_conta = event.target.checked;
                                onChange({ ...dadosBancarios })
                            }
                            handleValidChange();
                        }}
                        name="dados.bancarios.autorizar"
                    />}
                    label={<>Autorizar <strong>débito em conta</strong></>}
                />
            </div>
             <div className="X12">
                <Alert severity="warning">
                    {permiteDebitoEmConta !== true && (<>
                        <p>O pagamento do financiamento será efetuado obrigatoriamente via boleto</p>
                    </>)}
                    {permiteDebitoEmConta === true && (<>
                        <p>Caso não seja selecionado o <strong>débito em conta</strong>, pagamento do financiamento será efetuado obrigatoriamente via boleto</p>
                    </>)}
                </Alert>
            </div>
        </div>
        <div className="row">
            <div className="X12 M6">
                <InputComboBoxList
                    disabled={true}
                    label="Banco"
                    textField="nome"
                    valueField="id"
                    value={bancoSelecionado}
                    options={bancosListState?.data || []}
                    renderOptions={(option: any) => {
                        return `${option.id} - ${option.nome}`
                    }}
                    renderOptionsLabel={(option: any) => {
                        return `${option.id} - ${option.nome}`
                    }}
                    onChange={(_banco) => {
                        dadosBancarios.banco = _banco.id
                        onChange({ ...dadosBancarios })
                        handleValidChange();
                    }}
                />
            </div>
            <div className="X12 M6">
                <InputComboBoxList
                    disabled={readonly || !dadosBancarios?.debito_em_conta}
                    label="Tipo"
                    textField="nome"
                    valueField="id"
                    value={tipoConta}
                    options={TIPO_CONTA}
                    onChange={(_tipo) => {
                        dadosBancarios.tipo = _tipo?.id || null
                        onChange({ ...dadosBancarios })
                        handleValidChange();
                    }}
                />
            </div>
        </div>
        <div className="row">
            <div className="X12 M6">
                <InputText
                    disabled={readonly || !dadosBancarios?.debito_em_conta}
                    fullWidth
                    label="Agência"
                    value={dadosBancarios?.agencia}
                    onChange={(event: any) => {
                        if (dadosBancarios) {
                            dadosBancarios.agencia = event.target.value;
                            onChange({ ...dadosBancarios })
                        }
                    }}
                    onBlur={(event: any) => {
                        let _errors: string[] = errors
                        if (event.target.value !== "" && event.target.value.length < 4) {
                            _errors.push("agencia")
                        } else {
                            _errors = _errors.filter((error) => error !== "agencia")
                        }
                        setErrors([..._errors]);
                    }}
                    error={errors.includes("agencia")}
                />
            </div>
            <div className="X12 M4">
                <InputText
                    disabled={readonly || !dadosBancarios?.debito_em_conta}
                    fullWidth
                    label="Conta"
                    value={dadosBancarios?.conta}
                    onChange={(event: any) => {
                        if (dadosBancarios) {
                            dadosBancarios.conta = event.target.value;
                            onChange({ ...dadosBancarios })
                        }
                    }}
                    onBlur={(event: any) => {
                        let _errors: string[] = errors
                        if (event.target.value !== "" && event.target.value.length < 4) {
                            _errors.push("conta")
                        } else {
                            _errors = _errors.filter((error) => error !== "conta")
                        }
                        setErrors([..._errors]);
                    }}
                    error={errors.includes("conta")}
                />
            </div>
            <div className="X12 M2">
                <InputText
                    disabled={readonly || !dadosBancarios?.debito_em_conta}
                    fullWidth
                    label="Dígito"
                    value={dadosBancarios?.conta_digito}
                    onChange={(event: any) => {
                        if (dadosBancarios) {
                            dadosBancarios.conta_digito = event.target.value;
                            onChange({ ...dadosBancarios })
                        }
                        handleValidChange();
                    }}
                />
            </div>
        </div>

        <div className="row">
            <Alert severity="warning" className="texto-alerta">
                Se a opção de débito em conta não estiver disponível ou não for marcada, o pagamento do financiamento será efetuado através de <strong>boleto bancário</strong>.
            </Alert>
        </div>
    </div>
}

export { FormDadosBancarios }